import React, { useState, useEffect } from "react";
import "./onTrend.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { EffectCoverflow } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";

const OnTrendPicks = () => {
  const [slides, setSlides] = useState([]);
  const navigate = useNavigate();

  const handleButtonClick = (redirectUrl) => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/shop");
    }
  };

  useEffect(() => {
    const fetchSlidesImages = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/homepage/on-trend-picks/get-all`
        );
        // Ensure we get an array of slide objects
        setSlides(response.data);
      } catch (error) {
        console.error("Error fetching on-trend picks images:", error);
      }
    };

    fetchSlidesImages();
  }, []);

  return (
    <div className="trend-container">
      <h1>On Trend Picks</h1>
      <Swiper
        className="Ontrends-swiper"
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 0,
          stretch: 10,
          depth: 200,
          modifier: 1,
          slideShadows: false,
        }}
        modules={[EffectCoverflow]}
        initialSlide={1}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id} className="swiperslide">
            <img src={slide.url} alt={`Slide ${index + 1}`} />
            <button
              className="ontrends-explore-btn"
              onClick={() => handleButtonClick(slide.redirectUrl)}
            >
              Explore Now
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default OnTrendPicks;
